import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const revenueApi = createApi({
  reducerPath: 'revenueApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['revenue'],
  endpoints: (builder) => ({
    getRevenueData: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.revenueController.getRevenueData}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    getRevenueDataByParking: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.revenueController.getRevenueDataByParking}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    saveInvoiceDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.revenueController.saveInvoiceDetail}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateInvoiceDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.revenueController.updateInvoiceDetail}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    payToVendor: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.revenueController.payToVendor}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useGetRevenueDataMutation,
  useSaveInvoiceDetailMutation,
  useUpdateInvoiceDetailMutation,
  useGetRevenueDataByParkingMutation,
  usePayToVendorMutation,
} = revenueApi;
